import React, { useState } from 'react';
import './App.css';
import LogoSelect from './LogoSelect';
import FixedPricingTable from './FixedPricingTable';
import PricingOverwriteTable from './PricingOverwriteTable';
import Table from 'react-bootstrap/Table';

function App() {
  const [decorationCost, setDecorationCost] = useState(0);
  const [wholesaleCost, setWholesaleCost] = useState(0);
  const [numberOfLogos, setNumberOfLogos] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [totalHardCost, setTotalHardCost] = useState(0);
  const [totalHCPerItem, setTotalHCPerItem] = useState(0);
  const [selectedSize, setSelectedSize] = useState('');
  const [margin, setMargin] = useState(0);
  const [selectedMargin, setSelectedMargin] = useState(0);
  const [overwriteCost, setOverwriteCost] = useState(0);
  const [shouldOverwrite, setShouldOverwrite] = useState(false);
  const [fee, setFee] = useState(0);


  const handlePriceChange = (price) => {
    setDecorationCost(price);
    calculateTotalHardCost(wholesaleCost, price, numberOfLogos, quantity, fee);
  };

  const handleWholesaleCostChange = (event) => {
    const value = parseFloat(event.target.value) || 0;
    setWholesaleCost(value);
    calculateTotalHardCost(value, decorationCost, numberOfLogos, quantity, fee);
  };

  const handleNumberOfLogosChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    setNumberOfLogos(value);
    calculateTotalHardCost(wholesaleCost, decorationCost, value, quantity, fee);
  };

  const handleQuantityChange = (selectedQuantity) => {
    setQuantity(selectedQuantity);
    calculateTotalHardCost(wholesaleCost, decorationCost, numberOfLogos, selectedQuantity, fee);
  };

  const handleAdditionalFeeChange = (additionalCost) => {
    setFee(additionalCost);
    //console.log({additionalCost});
    calculateTotalHardCost(wholesaleCost, decorationCost, numberOfLogos, quantity, additionalCost);
  };

  const handleSizeChange = (size) => {
    setSelectedSize(size);
  };

  const handleMarginChange = (event) => {
    const value = parseFloat(event.target.value) || 0;
    setSelectedMargin(value);
  };

  const handleOverwriteChange = (event) => {
    
    setShouldOverwrite(event.target.checked);
    if (!event.target.checked) {
      setOverwriteCost(null); // Reset the overwrite cost if the option is unchecked
    }
  };

  const handleOverwriteCostChange = (event) => {
    const value = parseFloat(event.target.value) || 0;

    setOverwriteCost(value);
    
  };

  const getMargin = (qty) => {
    if (qty <= 12) return 1.48;
    if (qty <= 25) return 1.45;
    if (qty <= 50) return 1.43;
    if (qty <= 100) return 1.38;
    return 1.35;
  };

  const calculateTotalHardCost = (wholesale, decoration, logos, qty, fee) => {
    // if (decoration !== null) {
      const numericFee = parseFloat(fee);
      const totalCost = ((wholesale + decoration * logos) * qty);
      //console.log({additionalCost});
      //console.log(numericFee);
      // setTotalHardCost(totalCost);

      //const FinalHardCost = totalCost + additionalCost;


      setTotalHardCost(totalCost+numericFee);

      //setTotalHardCost(FinalHardCost);
      let hcPerItem = qty > 0 ? totalCost / qty : 0;
      // if (shouldOverwrite && overwriteCost !== null) {
      //   hcPerItem = overwriteCost;
      // }
      const margin = selectedMargin || getMargin(qty);
      setMargin(margin);
      setTotalHCPerItem(hcPerItem);
    
  };

  //const FinalHardCost = parseFloat(totalHardCost) + parseFloat(additionalCost);
  

  return (
    <div className='layout-size container'>
      <h1>Basic Unit Price Calculator</h1>
      <hr></hr>
      <h6>Please select a Logo Size and Enter Quantity</h6>
      <LogoSelect onPriceChange={handlePriceChange} onQuantityChange={handleQuantityChange} onSizeChange={handleSizeChange} onCostChange={handleAdditionalFeeChange} /><br></br>

      <Table striped bordered size="sm">
        <tbody>
          <tr>
            <td><label>Wholesale Cost : </label></td>
            <td>$<input type='number'
                 min='0'
                 max='20'
                 className='input-gap'
                 value={wholesaleCost}
                 onChange={handleWholesaleCostChange}
          ></input></td>
          </tr>
          <tr>
            <td><label>Decoration Cost : </label></td>
            <td>${decorationCost !== null ? decorationCost : '0'}</td>
          </tr>
          <tr>
            <td><label>No. of Logos : </label></td>
            <td><input type='number'
                 step="1"
                 min='0'
                 max='10'
                 className='input-gap'
                 value={numberOfLogos}
                 onChange={handleNumberOfLogosChange}
          ></input></td>
          </tr>
          <tr>
            <td>Original Hard Cost Per Item : </td>
            <td>${totalHCPerItem.toFixed(2)}</td>
          </tr>
         <tr>
            <td> <label>Quantity : </label></td>
            <td>{quantity}</td>
          </tr>
          <tr>
            <td>Hard Cost : </td>
            <td>${(totalHardCost - fee).toFixed(2)} + ${fee} = ${totalHardCost.toFixed(2)} </td>
          </tr>
          <tr>
            <td> <label>Desired Margin : </label></td>
            <td>
              <select value={selectedMargin} onChange={handleMarginChange}>
                  <option value="">Default</option>
                  <option value="1.48">1.48</option>
                  <option value="1.45">1.45</option>
                  <option value="1.43">1.43</option>
                  <option value="1.38">1.38</option>
                  <option value="1.35">1.35</option>
              </select>
              { 
                totalHardCost && selectedMargin && quantity > 0 
                  ? `$${(totalHardCost * selectedMargin).toFixed(2)} / $${(totalHardCost * selectedMargin / quantity).toFixed(2)}`
                  : "$0 / $0"
              }
            </td>
          </tr>
          <tr>
            <td>Options : </td>
            <td>
              <input
                type="checkbox"
                name="overwrite"
                checked={shouldOverwrite}
                onChange={handleOverwriteChange}
              /> Overwrite Cost Per Item   
              {shouldOverwrite && (
                <>
                  $
                  <input
                    type='number'
                    step="1"
                    min='1'
                    max='100'
                    className='input-gap'
                    value={overwriteCost !== null ? overwriteCost : ''}
                    onChange={handleOverwriteCostChange}
                  />
                </>
              )}
            </td>
          </tr>
          {/* <tr>
            <td>Overwrite Margin : </td>
            <td>
              {
                overwriteCost && totalHCPerItem > 0 
                  ? (overwriteCost / totalHCPerItem).toFixed(2) 
                  : "0.00"
              }
            </td>
          </tr> */}
        </tbody>
      </Table>
      <FixedPricingTable selectedSize={selectedSize} numberOfLogos={numberOfLogos} wholesaleCost={wholesaleCost} desiredMargin={margin > 0 ? margin : 'N/A'} totalHardCost={totalHardCost} fee={fee} />
      {shouldOverwrite && 
        <PricingOverwriteTable selectedSize={selectedSize} numberOfLogos={numberOfLogos} wholesaleCost={wholesaleCost} desiredMargin={margin > 0 ? margin : 'N/A'} overwriteCost={overwriteCost} totalHCPerItem={totalHCPerItem} quantity={quantity} />
      }
    </div>
  );
}

export default App;
